import React, { useEffect, useRef } from "react";
import { Colors } from "src/assets/colors/Colors";
import AgGridTable from "src/components/AgGridTable";

const COLUMN_DEF = [
    {headerName: "Fila Excel", field: "row", minWidth: 100, resizable: true, sortable: false, filter: false},
    {headerName: "Descripción", field: "msg", minWidth: 460, resizable: true, sortable: false, filter: false}
];

const TableErrorExcel = ({properties}) => {
    const { data } = properties;
    const tableRef = useRef(null);

    const countErrorRef = useRef(null);

    useEffect(() => {
        countErrorRef.current.innerText = data.length ?? 0;
    }, []);

    return(
        <React.Fragment>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center w-75 pl-3">
                    <div>
                        <strong className="mr-2">Cantidad de errores:</strong>
                        <span 
                            ref={countErrorRef} 
                            className="mr-2"
                            style={{fontSize: 20, color: Colors.RED_SWITCH_INACTIVE, fontWeight: 'bold'}}>0</span>
                    </div>
                </div>
            </div>
            <AgGridTable
                referencia={tableRef}
                columnDef={COLUMN_DEF}
                dataList={data}
                onGridReady={params => params.api.sizeColumnsToFit()}
            />
        </React.Fragment>
    )
}

export default TableErrorExcel